// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".decision_header_title-module__container--3IHp4{font-weight:600;font-size:16px;line-height:24px;letter-spacing:0px;font-size:17px;text-align:left;width:100%}.decision_header_title-module__title--3Sz9V{cursor:pointer;color:#36b}.decision_header_title-module__title--3Sz9V:hover{text-decoration:underline}.decision_header_title-module__title--3Sz9V:visited{color:#8b1aa8}.decision_header_title-module__title--3Sz9V:active{color:#8b1aa8}.decision_header_title-module__visited--3oQsY{color:#8b1aa8}\n", ""]);
// Exports
exports.locals = {
	"container": "decision_header_title-module__container--3IHp4",
	"title": "decision_header_title-module__title--3Sz9V",
	"visited": "decision_header_title-module__visited--3oQsY"
};
module.exports = exports;
